import { render } from "./CookiesImageCropper.vue?vue&type=template&id=5377946f&scoped=true&ts=true"
import script from "./CookiesImageCropper.vue?vue&type=script&lang=ts"
export * from "./CookiesImageCropper.vue?vue&type=script&lang=ts"

import "./CookiesImageCropper.vue?vue&type=style&index=0&id=5377946f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5377946f"]])

export default __exports__